let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7C5bc")).then(() => parcelRequire('7uVkM'));